'use client';

import ErrorPage from '@/components/ErrorPage';
import { INotFoundDictionary } from '@/dictionaries/utils/notFound/types';
import { useEffect } from 'react';

interface IError {
  error: Error & { digest?: string };
  reset: () => void;
}

const dict = {
  title: 'Unexpected Error',
  description: 'Please contact the customer service',
};

export default function Error({ error, reset }: IError) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <ErrorPage
      errorType="error"
      dict={
        {
          error: dict,
        } as INotFoundDictionary
      }
      lang={'en'}
    />
  );
}
